import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=4b1c7e9e&scoped=true&"
import script from "./addSection.vue?vue&type=script&lang=js&"
export * from "./addSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c7e9e",
  null
  
)

export default component.exports